import {useSearchParams} from 'react-router-dom';

const useLangCode = () => {
  const [searchParams] = useSearchParams();
  if (searchParams.get('l')) {
    return searchParams.get('l');
  }
  return 'en';
};

export default useLangCode;
